import { render } from "./GibergNiura.vue?vue&type=template&id=37329071&scoped=true"
import script from "./GibergNiura.vue?vue&type=script&lang=js"
export * from "./GibergNiura.vue?vue&type=script&lang=js"

import "./GibergNiura.vue?vue&type=style&index=0&id=37329071&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37329071"]])

export default __exports__